import {
  DEFAULT_PROFILE_ACCENT,
  normalizeProfileAccentColor,
} from '@up2stay/up2promo-ui';

import { getAbsoluteFileUrl } from '@/core/lib/file-url';

export function workspaceBrandLogoUrl(
  photo?: { path?: string | null } | null,
): string | undefined {
  const path = typeof photo?.path === 'string' ? photo.path.trim() : '';
  return path ? getAbsoluteFileUrl(path) : undefined;
}

export function workspaceBrandAccent(accent?: string | null): string {
  return normalizeProfileAccentColor(accent) ?? DEFAULT_PROFILE_ACCENT;
}
